//@ts-nocheck
import React from "react";
import { Row, Col } from "antd";
import moment from "moment";
import { DownloadOutlined } from "@ant-design/icons";
import { downloadPayrunRejectionFile } from "../../actions/payrun";

let label = 7;
let value = 17;

const PayrunDeclineReason = ({ description }: any) => {
  const handleDownload = () => {
    const fileData = {
      id: description.rejectionReason.attachment.id,
      fileName: description.rejectionReason.attachment.displayName,
    };
    downloadPayrunRejectionFile(fileData);
  };

  return (
    <React.Fragment>
      <Row className="mb-1">
        <Col span={label}>
          <b>Rejected by:</b>
        </Col>
        <Col span={value}>{description?.user?.userName}</Col>
      </Row>
      <Row className="mb-1">
        <Col span={label}>
          <b>Date:</b>
        </Col>
        <Col span={value}>
          {moment(description?.user?.date).format("DD/MM/YYYY hh:mm A")}
        </Col>
      </Row>
      <Row className="mb-1">
        <Col span={label}>
          <b>Reason:</b>
        </Col>
        <Col span={value}>{description?.rejectionReason?.description}</Col>
      </Row>
      <Row>
        <Col span={label}>
          <b>Category:</b>
        </Col>
        <Col span={value}>{description?.rejectionReason?.errorCategory}</Col>
      </Row>
      {description?.rejectionReason?.attachment?.id && (
        <Row>
          <Col span={label}>
            <b>Attachment:</b>
          </Col>
          <Col span={value}>
            <DownloadOutlined />{" "}
            <button
              data-id={description.rejectionReason.attachment.id}
              onClick={handleDownload}
            >
              {description.rejectionReason.attachment.displayName}
            </button>
          </Col>
        </Row>
      )}
    </React.Fragment>
  );
};
export default PayrunDeclineReason;
